export const TIMING = {
    DEFAULT: 500,
    SLOW: 6000,
};

export const HTTP = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE',
};

export const ERROR_KEYS = {
    BAD_REQUEST: 'BAD_REQUEST',
    NOT_AUTHORIZED: 'NOT_AUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    REQUEST_TIMEOUT: 'REQUEST_TIMEOUT',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    BAD_GATEWAY: 'BAD_GATEWAY',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
};

export const RESPONSE_TIMERS = {
    RETRY_AFTER: 1000,
};
